import { site } from "../../siteConfig";
import { siteImages } from "../../content/website";
import type { HoursSection, IndustryContent } from "../../content/industry";
import { SectionHeading } from "./SectionHeading";

/** Horarios y ubicación (los datos vienen de industry.contact). */
export function Visit({ section, contact }: { section: HoursSection; contact: IndustryContent["contact"] }) {
  return (
    <section id={section.id} className="ix-section ix-surface ix-visit" aria-labelledby={`${section.id}-title`}>
      <div className="ix-container ix-split">
        <div><SectionHeading id={section.id} eyebrow={section.eyebrow} title={section.title} text={section.text} />
          <p className="ix-address">{contact.address}</p>
          <a className="ix-button ix-button--ghost" href={contact.mapUrl} target="_blank" rel="noreferrer">Abrir en el mapa</a>
        </div>
        <dl className="ix-hours">{contact.hours.map(item => <div key={item.days}><dt>{item.days}</dt><dd>{item.time}</dd></div>)}</dl>
      </div>
    </section>
  );
}

/** Pie con marca, contacto, horario, redes, créditos de las fotografías (exigidos por CC BY) y aviso de contenido de ejemplo. */
export function SiteFooter({ content }: { content: IndustryContent }) {
  const year = new Date().getFullYear();
  const credited = siteImages.filter(image => image.creator || image.license);
  return (
    <footer className="ix-footer">
      <div className="ix-container ix-footer-grid">
        <div><p className="ix-footer-brand">{site.name}</p><p>{site.tagline}</p><p>{content.footer.about}</p></div>
        <div><h2>Contacto</h2><p>{content.contact.address}</p><p><a href={`mailto:${site.email}`}>{site.email}</a></p><p><a href={`tel:${site.phone.replace(/[^+\d]/g, "")}`}>{site.phone}</a></p></div>
        <div><h2>Horario</h2><dl>{content.contact.hours.map(item => <div key={item.days}><dt>{item.days}</dt><dd>{item.time}</dd></div>)}</dl></div>
        <div><h2>Síguenos</h2><ul>{content.contact.social.map(link => <li key={link.href}><a href={link.href} target="_blank" rel="noreferrer">{link.label}</a></li>)}</ul></div>
      </div>
      {credited.length > 0 && (
        <details className="ix-container ix-credits">
          <summary>Créditos de las fotografías</summary>
          <ul>{credited.map(image => <li key={image.source}>
            {image.pageUrl ? <a href={image.pageUrl} target="_blank" rel="noreferrer">{image.title || image.alt}</a> : image.title || image.alt}
            {image.creator ? ` · ${image.creator}` : ""}
            {image.licenseUrl ? <> · <a href={image.licenseUrl} target="_blank" rel="noreferrer">{image.license}</a></> : image.license ? ` · ${image.license}` : ""}
            {image.provider ? ` · ${image.provider}` : ""}
          </li>)}</ul>
        </details>
      )}
      <div className="ix-container ix-footer-legal"><p>© {year} {site.name}. {content.footer.legal}</p><p>{content.disclaimer}</p></div>
    </footer>
  );
}
